import { C, P0, S, abs, fillAt, rotPts } from '../../geometry';

export const kite = {
  name: 'Kite',
  colors: ['#3E63DD', '#E5484D'],
  draw(m, t) {
    let rot = 4 * S(t * 1.1),
      tx = 0,
      ty = 0,
      wv = 3,
      sp = 2,
      droop = 0,
      pose = P0();
    if (m === 'happy') {
      rot = 15 * S(t * 6);
      ty = -3 * abs(S(t * 6));
      wv = 6;
      sp = 9;
    }
    // Thinking: swoops in a slow figure of eight, tail streaming.
    if (m === 'thinking') {
      tx = 8 * S(t * 1.2);
      ty = 4 * S(t * 2.4);
      rot = 12 * C(t * 1.2);
      wv = 5;
      sp = 4;
    }
    if (m === 'talking') {
      wv = 4;
      sp = 7;
      rot = 3 * S(t * 9);
    }
    if (m === 'surprised') {
      ty = -6;
      rot = 0;
      wv = 1;
    }
    if (m === 'paused') {
      rot = 25 + S(t * 0.7);
      ty = 4;
      wv = 0.5;
      sp = 0.6;
      droop = 1;
    }
    const kite = rotPts(
      [
        [50, 14],
        [72, 40],
        [50, 70],
        [28, 40],
        [50, 14],
      ],
      50,
      40,
      rot
    ).map(([x, y]) => [x + tx, y + ty]);
    const base = kite[2];
    const tail = [0, 1, 2, 3, 4].map((j) => [
      base[0] + (j ? wv * S(t * sp - j * 1.1) : 0) - j * 3 * (1 - droop),
      base[1] + j * 6,
    ]);
    const bows = [2, 4].map((j) => ({
      c: 'b',
      pts: [
        [tail[j][0] - 4, tail[j][1]],
        [tail[j][0] + 4, tail[j][1]],
      ],
      detail: true,
    }));
    const eye = rotPts([[50, 40]], 50, 40, rot)[0];
    return {
      strokes: [
        { c: 'a', pts: kite, sharp: true, n: 36 },
        { c: 'b', pts: tail },
        ...bows,
      ],
      eyes: { x: eye[0] + tx, y: eye[1] + ty },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
